import { all, put, call, takeLatest } from 'redux-saga/effects';
import { getStatusCode } from 'client/ErrorHandler';
import { AxiosResponse } from 'axios';
import { AccountAPI } from 'client/api.config';
import dayjs from 'dayjs';
import { StatementResponse, StatementTypes } from './types';
import statementListActions from './actions';
import { displayUserInfo } from '../user/actions';
import { serializeAccountInfo } from 'client/utils/token';

const { request, success, failure } = statementListActions;

export function* fetchStatements({
  payload,
}: ReturnType<typeof request>): Generator<any, void, any> {
  try {
    const {
      periodEnd,
      periodStart,
      reportType,
      offset,
      limit,
      document,
      update,
    } = payload;

    const requestData = {
      reportType,
      periodStart,
      periodEnd,
      offset,
      limit,
      document,
    };

    const requestUrl = Object.entries(requestData).reduce(
      (url, [key, value], index) => {
        const mark = index === 0 ? '?' : '&';
        if (!value) return url;
        const requestValue =
          value instanceof Date ? dayjs(value).format('YYYY-MM-DD') : value;
        return url + `${mark}${key}=${requestValue}`;
      },
      ''
    );

    const response: AxiosResponse<StatementResponse> = yield call(
      AccountAPI.get,
      `/v1/accounts/statement${requestUrl}`
    );

    const { data } = response;
    yield put(
      success({
        ...data,
        Update: update,
        LastUpdated: dayjs().format('MMMM D, YYYY - hh:mm a'),
      })
    );
    yield put(displayUserInfo(data.PersonalInfo.Name));
    serializeAccountInfo({ ...data.PersonalInfo });
  } catch (error) {
    const statusCode = getStatusCode(error);
    yield put(failure(statusCode));
  }
}

export default function* (): Generator<any, void, any> {
  return yield all([
    takeLatest(StatementTypes.FetchListRequest, fetchStatements),
  ]);
}
